import type Lenis from "lenis";

let instance: Lenis | null = null;

export function setLenisInstance(lenis: Lenis | null) {
  instance = lenis;
}

export function getLenisInstance(): Lenis | null {
  return instance;
}

// Whether the user is mid-scroll. Set by the smooth-scroll provider; read by refresh helpers so
// they can defer a ScrollTrigger.refresh() until scroll-idle (a refresh mid-gesture tugs the
// scroll position backwards and reads as a freeze).
let scrollingGetter: () => boolean = () => false;

export function setScrolling(getter: () => boolean) {
  scrollingGetter = getter;
}

export function isScrolling(): boolean {
  return scrollingGetter();
}
